<template>
  <div class="pickup-points" :class="blockClass">
    <div class="pickup-points__title">
      Адреса пунктов выдачи
    </div>

    <div class="pickup-points__wrap">
      <div class="pickup-points__list" style="overflow: scroll;" data-points-list>
        <div class="pickup-points__item" :data-pont-id="point.id" v-for="point in points">
          <ThePickupPoint :point="point"/>
        </div>
      </div>

      <div class="pickup-points__map-wrap">
        <div class="pickup-points__map" id="deliveryMap" data-cart-map></div>
      </div>
    </div>
  </div>
</template>

<script>
import ThePickupPoint from "./ThePickupPoint.vue";

export default {
  name: "ThePickupPoints",
  components: {
    ThePickupPoint
  },
  props: {
    blockClass: {
      type: String,
      default: "",
    },
    points: {
      type: Array,
      required: true,
    },
  },
}
</script>